export function headerFunc() {
  toggleMenu()
  adjustHeaderPadding();
  window.addEventListener('resize', adjustHeaderPadding);
}

/**
 * ハンバーガーメニュー
 */
function toggleMenu() {
  const toggleButton = document.querySelector('.l-header__toggle');
  const toggleText = document.querySelector('.l-header__toggle-text');
  const nav = document.querySelector('.l-header__right');

  toggleButton.addEventListener('click', function() {
    toggleButton.classList.toggle('is-active');
    if (toggleButton.classList.contains('is-active')) {
      toggleText.textContent = '閉じる';
      nav.classList.add('is-active');
    } else {
      toggleText.textContent = 'メニュー';
      nav.classList.remove('is-active');
    }
  });

};

/**
 * ヘッダーの高さに合わせてbodyのpadding-topを調整
 */
function adjustHeaderPadding() {
  const header = document.getElementById('header');
  const body = document.body;

  if (header) {
    const headerHeight = header.offsetHeight;
    body.style.paddingTop = `${headerHeight}px`;
  }
}